import { app } from '@microsoft/teams-js'
import { useThemeStore } from '@/stores/theme'

let inTeams = false

export function isInTeams() {
  return inTeams
}

function applyTeamsTheme(theme) {
  // Teams expone 'default' | 'dark' | 'contrast'. Mapeamos a light/dark.
  const mode = theme === 'dark' || theme === 'contrast' ? 'dark' : 'light'
  useThemeStore().set(mode)
}

// Inicializa el SDK de Teams. Si la app NO corre dentro de Teams,
// app.initialize() rechaza y devolvemos false sin tocar nada (no-op en web).
export async function initTeams() {
  // Idempotente: si ya inicializamos dentro de Teams, no re-registrar el
  // handler de tema ni re-notificar.
  if (inTeams) return true

  try {
    await app.initialize()
  } catch {
    inTeams = false
    return false
  }

  inTeams = true

  try {
    const context = await app.getContext()
    applyTeamsTheme(context?.app?.theme)
    app.registerOnThemeChangeHandler(applyTeamsTheme)
  } catch (e) {
    // El tema es best-effort; no debe impedir notificar el éxito de carga.
    console.warn('[teams] theme setup failed', e)
  }

  // Apaga el spinner de carga de Teams.
  app.notifySuccess()
  return true
}
